import { render, staticRenderFns } from "./branch_more_actions.vue?vue&type=template&id=0ad84378"
import script from "./branch_more_actions.vue?vue&type=script&lang=js"
export * from "./branch_more_actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports